import React from 'react'
import { DomesticCartProductSection } from '~/api/converters/domestic/cart/ProductSection/index.type'
import LeisureItem from './items/leisure'
import PropertyItem from './items/property'
import BusItem from './items/bus'
import TrainItem from './items/train'

const CartProductSection = ({ cartItems }: DomesticCartProductSection) => {
  return (
    <div className="flex flex-col gap-16">
      {cartItems.map((item, idx) => {
        if (item.type === 'DOMESTIC_RESERVATION') {
          return <PropertyItem key={idx} item={item} />
        }
        if (item.type === 'DOMESTIC_LEISURE') {
          return <LeisureItem key={idx} item={item} />
        }
        if (item.type === 'DOMESTIC_BUS') {
          return <BusItem key={idx} item={item} />
        }
        if (item.type === 'DOMESTIC_TRAIN') {
          return <TrainItem key={idx} item={item} />
        }
      })}
    </div>
  )
}

export default CartProductSection
